<template>
  <section>
    <div
      class="modal-card"
      style="width: auto"
    >

      <header class="modal-card-head">
        <div class="title is-bold">Update Property Attributes</div>
      </header>

      <section class="modal-card-body">

        <div class="subtitle is-bold">Change any of the property attributes that need to be updated, then click Save Changes.</div>

        <b-field
          horizontal
          label="Beds"
        >
          <b-input
            @focus="$event.target.select()"
            name="beds"
            v-model="c.beds"
            type="number"
            expanded
          >
          </b-input>
        </b-field>

        <b-field
          horizontal
          label="Baths"
        >
          <b-input
            @focus="$event.target.select()"
            name="baths"
            v-model="c.baths"
            type="number"
            expanded
          >
          </b-input>
        </b-field>

        <b-field
          horizontal
          label="Garage"
        >
          <b-input
            @focus="$event.target.select()"
            name="garage"
            v-model="c.garage"
            type="number"
            expanded
          >
          </b-input>
        </b-field>

        <b-field
          horizontal
          label="Sqft"
        >
          <b-input
            @focus="$event.target.select()"
            name="sqft"
            v-model="c.sqft"
            type="number"
            expanded
          >
          </b-input>
        </b-field>

        <b-field
          horizontal
          label="Year Built"
        >
          <b-input
            @focus="$event.target.select()"
            name="yearBuilt"
            v-model="c.yearBuilt"
            type="number"
            expanded
          >
          </b-input>
        </b-field>

        <b-field
          horizontal
          label="Subdivision"
        >
          <b-input
            @focus="$event.target.select()"
            name="subdivision"
            v-model="c.subdivision"
            type="text"
            expanded
          >
          </b-input>
        </b-field>

        <div class="is-divider"></div>

        <b-field
          horizontal
          label="MLS Market"
        >
          <b-select
            placeholder="Select a market"
            name="mlsMarket"
            v-model="c.mlsMarket"
            expanded
          >
            <option value="NotSet">
              Not Set - No market specified
            </option>
            <option
              v-for="(mlsMarket, key) in $store.state.mlsMarkets"
              :key="key"
              v-bind:value="mlsMarket.acronym"
            >
              {{ mlsMarket.acronym }} - {{ mlsMarket.description }}
            </option>
          </b-select>
        </b-field>

        <b-field
          horizontal
          label="List Price $"
        >
          <b-input
            @focus="$event.target.select()"
            name="listPrice"
            v-model="c.listPrice"
            type="number"
            expanded
          >
          </b-input>
        </b-field>

        <b-field
          horizontal
          label="HOA Annual $"
        >
          <b-input
            @focus="$event.target.select()"
            name="hoaAnnual"
            v-model="c.hoaAnnual"
            type="number"
            expanded
          >
          </b-input>
        </b-field>

        <b-field
          horizontal
          label="Taxes Annual $"
        >
          <b-input
            @focus="$event.target.select()"
            name="taxesAnnual"
            v-model="c.taxesAnnual"
            type="number"
            expanded
          >
          </b-input>
        </b-field>

        <b-message
          type="is-danger"
          has-icon
          v-if="this.errorMessage"
        >
          {{ this.errorMessage }}
        </b-message>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          @click="() => { cancel(); $parent.close() }"
        >Cancel</button>
        <button
          class="button is-primary"
          @click="() => { saveEdit(); $parent.close() }"
        >Save changes</button>
      </footer>

    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      errorMessage: "",
      c: {
        baths: "",
        beds: "",
        garage: "",
        hoaAnnual: "",
        listPrice: "",
        mlsMarket: "",
        sqft: "",
        subdivision: "",
        taxesAnnual: "",
        yearBuilt: ""
      }
    };
  },

  computed: {
    connection() {
      return this.$store.state.connectionEdit.connection;
    },
    originalConnection() {
      return this.$store.state.connectionEdit.originalConnection;
    }
  },

  mounted() {
    console.log("mounted()", this.$store.state.evaluation);
    this.$store.dispatch("getMlsMarkets");
    this.c.baths = this.$store.state.evaluation.baths;
    this.c.beds = this.$store.state.evaluation.beds;
    this.c.garage = this.$store.state.evaluation.garage;
    this.c.hoaAnnual = this.$store.state.evaluation.hoaAnnual;
    this.c.listPrice = this.$store.state.evaluation.listPrice;
    this.c.mlsMarket = this.$store.state.evaluation.mlsMarket;
    this.c.sqft = this.$store.state.evaluation.sqft;
    this.c.subdivision = this.$store.state.evaluation.subdivision;
    this.c.taxesAnnual = this.$store.state.evaluation.taxesAnnual;
    this.c.yearBuilt = this.$store.state.evaluation.yearBuilt;
  },

  methods: {
    cancel() {
      console.log("cancel()");
    },

    async saveEdit() {
      console.log("saveEdit()", this.c);
      var propertyId = this.$store.state.evaluation.propertyId;
      var evaluationId = this.$store.state.evaluation.id;
      var baths = this.c.baths;
      var beds = this.c.beds;
      var county = null;
      var garage = this.c.garage;
      var hoaAnnual = this.c.hoaAnnual;
      var listDate = null;
      var listPrice = this.c.listPrice;
      var mlsMarket = this.c.mlsMarket;
      var sqft = this.c.sqft;
      var subdivision = this.c.subdivision;
      var taxesAnnual = this.c.taxesAnnual;
      var yearBuilt = this.c.yearBuilt;
      await this.$store.dispatch("updateEvaluationsPropertyAttributes", {
        propertyId,
        evaluationId,
        baths,
        beds,
        county,
        garage,
        hoaAnnual,
        listDate,
        listPrice,
        mlsMarket,
        sqft,
        subdivision,
        taxesAnnual,
        yearBuilt
      });
    }
  }
};
</script>

<style>
</style>
